import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import CurrencySelector from '../../CurrencySelector';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Common from './../../Common';
import Dialog from './../../Dialog';
import * as Picklist from "./../../Picklist";

const Rep_teller_sheet = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const HOCODE = sessionStorage.getItem('hocode');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [generateType, setGenerateType] = useState("V");

    const [scr, setScr] = useState("")
    const [filterLocationType, setFilterLocationType] = useState("O");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [currencyCode, setCurrencyCode] = useState('');
    const [selectedItems2, setSelectedItems2] = useState([]);
    const [radioType2, setRadioType2] = useState('A');
    const [filterIssuerType, setFilterIssuerType] = useState("A");
    const [issuer, setIssuer] = useState(null);
    const [groupCode, setGroupCode] = useState(0);
    const [accountCode, setAccountCode] = useState(0);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_TELLER_SHEET'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setIssuer(null);
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }

    const handleLocationType = (e) => {
        setIssuer(null);
        setFilterLocationType(e.target.value);
        if (e.target.value === 'A') {
            setLocationCode(0);
        } else {
            Common.getActiveBranch().then(response => {
                setFilterLocation(response);
                response != null && handleChangeLocation(response);
            });
        }
    }

    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if ((filterIssuerType === 'O' && issuer == null) || (radioType2 === 'S' && selectedItems2.length < 1) || (radioType2 === 'O' && currencyCode == '0')) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((filterIssuerType === 'O' && issuer == null) ? "Issuer." : '');
            msg[i++] = ((radioType2 === 'S' && selectedItems2.length < 1) ? "Select atleast one Currency." : '');
            msg[i++] = ((radioType2 === 'O' && currencyCode == '0') ? "Select Currency." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            $(".loader").hide();
        } else {
            const obj = {
                filterLocationType: filterLocationType,
                radioTypeLocation: filterLocationType,
                fromDate: Common.dateYMD(fromDate),
                fromDate1: Common.dateDMY(fromDate),
                toDate: Common.dateYMD(toDate),
                toDate1: Common.dateDMY(toDate),
                type: generateType,
                generateType: generateType,
                fromDateDMY: Common.dateDMY(fromDate),
                toDateDMY: Common.dateDMY(toDate),
                locationCode: locationCode,
                location: locationCode,
                filterIssuerType: 'A',
                showHeader: false,
                radioTypeCurrency: radioType2,
                currency: currencyCode,
                multipleCurrency: selectedItems2.length > 0 ? selectedItems2.split(',').join("','") : selectedItems2,
                groupCode: groupCode,
                accountCode: accountCode,
                showCheque: true,
            };
            if (generateType === 'D') {
                Common.callDownloadApiPost1(Common.apiRepTellerSheet, "post", [sid, 'getData', JSON.stringify(obj)], (result) => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else if (generateType === 'V') {
                Common.callApi(Common.apiRepTellerSheet, [sid, 'getData', JSON.stringify(obj)], (result) => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });
            }
        }
    }
    const handleDataFromChild2 = (newCurrencyCode, newSelectedItems2, newRadioType2) => {
        setCurrencyCode(newCurrencyCode);
        setSelectedItems2(newSelectedItems2);
        setRadioType2(newRadioType2);
    }
    const handleIssuerChange = (value) => {
        console.log(value);
        setIssuer(value);
        const iss = value.id.split('^');
        setGroupCode(iss[1]);
        setAccountCode(iss[2]);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                {scr === "" ?
                    <>
                        <Row>
                            <Col>
                                <h3>Teller Sheet</h3>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={filterLocationType} onChange={handleLocationType}
                                        required>
                                        <option value="O">One</option>
                                        <option value="A">All</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {filterLocationType === 'O' ? <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={filterLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col></> : null}
                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={fromDate}
                                        onChange={(date) => setFromDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>

                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={toDate}
                                        onChange={(date) => setToDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Row>
                            </Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Issuer All/One<span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={filterIssuerType} onChange={e => setFilterIssuerType(e.target.value)}
                                        required>
                                        <option value="A">All</option>
                                        <option value="O">One</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {filterIssuerType === 'O' ?
                                <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={issuer}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', filterLocationType === 'A' ? HOCODE : locationCode)}
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleIssuerChange}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                </> : null}
                            <Col className='col-md-6 col-6'>
                                <Form.Label>Currency Filter</Form.Label><br />
                                <CurrencySelector onDataFromChild2={handleDataFromChild2} />
                            </Col>
                        </Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                        required>
                                        <option value="V">View</option>
                                        <option value="D">Download</option>

                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                    </> : null}
                {/* {scr === "V" ? <>
                    <Row>
                        <Col>
                            <Button onClick={() => setScr('')} variant="primary">Back</Button>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    &nbsp;
                    <Table responsive striped bordered>
                        <thead>
                            <tr>
                                <th>ISD</th>
                                <th>Branch</th>
                                <th>Deno</th>
                                <th>Opn Bal</th>
                                <th>Purchase</th>
                                <th>Sale</th>
                                <th>Trans In</th>
                                <th>Trans Out</th>
                                <th>Change In</th>
                                <th>Change Out</th>
                                <th>Fake</th>
                                <th>Quant in Hand</th>
                                <th>Value</th>
                            </tr>
                        </thead>

                        <tbody>
                            {stockReportList.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.prd_isd}</td>
                                    <td>{item.prd_location + " " + item.entity_name}</td>
                                    <td>{item.prd_deno}</td>
                                    <td>{item.opn_bal}</td>
                                    <td>{item.purchase}</td>
                                    <td>{item.sales}</td>
                                    <td>{item.trans_in}</td>
                                    <td>{item.trans_out}</td>
                                    <td>{item.change_in}</td>
                                    <td>{item.change_out}</td>
                                    <td>{item.fake}</td>
                                    <td>{item.qty_in_hand}</td>
                                    <td>{item.value}</td>
                                </tr>
                            ))}
                        </tbody>
                        <Row>&nbsp;</Row>
                        <Row>&nbsp;</Row>
                        <thead>
                            <tr>
                                <th>Group</th>
                                <th>Group Name</th>
                                <th>Account</th>
                                <th>Ledger Name</th>
                                <th>Opening DR</th>
                                <th>Opening CR</th>
                                <th>Period DR</th>
                                <th>Period CR</th>
                                <th>Closing DR</th>
                                <th>Closing CR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trailReportList.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.tfd_group}</td>
                                    <td>{item.mvg_group_name}</td>
                                    <td>{item.tfd_account}</td>
                                    <td>{item.mvli_ledger_name}</td>
                                    <td>{item.opn_total_dr}</td>
                                    <td>{item.opn_total_cr}</td>
                                    <td>{item.prd_total_dr}</td>
                                    <td>{item.prd_total_cr}</td>
                                    <td>{item.cls_total_dr}</td>
                                    <td>{item.cls_total_cr}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                </> : null} */}
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_teller_sheet;
